module.exports = __webpack_public_path__ + "media/assets/images/flags/ai-b31604221e554fbfb68fae1bda0c69c2.svg";